// extracted by mini-css-extract-plugin
export default {"SponsorSlider":"SponsorSlider_SponsorSlider__Egc9a","Sponsors":"SponsorSlider_Sponsors__kZKnE"};